<template lang="html">

  <div class="cover-popup row-center">
    <div class="popup">

      <p>{{$t('popup_directorio_desactivado.titulo')}}</p>

      <div class="contenedor-botones">

        <router-link @click.native="$emit('hide')" :to="$t('enlaces.cv')" class="btn -solid-primary">{{$t('popup_directorio_desactivado.si')}}</router-link>

      </div>

    </div>
  </div>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex';
  
    export default  {
      name: 'popup-directorio-desactivado',
      data(){
        return {
        }
      },
      computed : {
        ...mapGetters({
          brand:'getBrand',
          style : 'getStyles'
        })
      },
      methods : {
        ...mapActions([])
      }
    }
  </script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-directorio-desactivado.vue